/* =========================================================
   HORTIGO OS V92.2 — assets/hg-v92.js
   Orchestrator UI:
   - updates badge (guest/member/premium/pending)
   - updates tokens text (#hgTok) live
   - locks tier buttons based on req tier + pending
   - re-applies locks when config/tokens change
========================================================= */

(() => {
  "use strict";

  function boot() {
    const HG = window.HG;
    if (!HG || !HG.state?.root) return;

    const root = HG.state.root;
    const iso = root.querySelector("#hg-iso");
    if (!iso) return;

    if (iso.getAttribute("data-hg-v92-bound") === "1") return;
    iso.setAttribute("data-hg-v92-bound", "1");

    const badge = iso.querySelector("#hgBadge");
    const tokEl = iso.querySelector("#hgTok");

    function setBadge() {
      if (!badge) return;

      const u = HG.state.user || {};
      badge.classList.remove("b-guest", "b-member", "b-prem", "b-pend");

      if (u.pending) {
        badge.textContent = "PENDING";
        badge.classList.add("b-pend");
        return;
      }

      if (u.tier === 2) {
        badge.textContent = "PREMIUM";
        badge.classList.add("b-prem");
        return;
      }
      if (u.tier === 1) {
        badge.textContent = "MEMBER";
        badge.classList.add("b-member");
        return;
      }

      badge.textContent = "GUEST";
      badge.classList.add("b-guest");
    }

    function setTokens() {
      if (!tokEl) return;
      tokEl.textContent = String(HG.state.user?.tok ?? 0);
    }

    function applyLocks() {
      const userTier = Number(HG.state.user?.tier ?? 0);
      const pending = !!HG.state.user?.pending;

      // Tier buttons across modules use .hg-tier with data-req
      iso.querySelectorAll(".hg-tier[data-req]").forEach((btn) => {
        const req = parseInt(btn.getAttribute("data-req") || "0", 10);
        const locked = pending || req > userTier;
        btn.classList.toggle("is-locked", locked);
      });
    }

    // initial
    setBadge();
    setTokens();
    applyLocks();

    // live updates
    document.addEventListener("hg:tokens-updated", () => {
      setTokens();
      setBadge();
      applyLocks();
    });

    document.addEventListener("hg:config-updated", () => {
      applyLocks();
    });
  }

  function bootSafe() {
    if (window.HG?.state?.root) boot();
  }

  // run when HG is ready
  document.addEventListener("hg:ready", () => {
    try { bootSafe(); } catch (_) {}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootSafe);
  } else {
    bootSafe();
  }

  document.addEventListener("shopify:section:load", () => {
    try { bootSafe(); } catch (_) {}
  });
})();
